import { render, staticRenderFns } from "./about.vue?vue&type=template&id=679211b4&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('679211b4')) {
      api.createRecord('679211b4', component.options)
    } else {
      api.reload('679211b4', component.options)
    }
    module.hot.accept("./about.vue?vue&type=template&id=679211b4&", function () {
      api.rerender('679211b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/info-blocks/about.vue"
export default component.exports